import algoliasearch, { SearchClient } from "algoliasearch";
import { UserSelf } from "storefront/User";
import fetchUserRestrictedSearchKey from "storefront/Algolia/fetchUserRestrictedSearchKey";

/**
 * @private
 * @description Creates an Algolia client that is that is unique to
 * the current user and only returns hits "visible by" that user.
 * Ideally, use our custom hook that utilizes this call, instead of this API call.
 */
const createUserRestrictedClient = (
  appId: string,
  currentUser: UserSelf,
): Promise<SearchClient> =>
  fetchUserRestrictedSearchKey(currentUser).then((key) =>
    algoliasearch(appId, key.value),
  );

export default createUserRestrictedClient;
